var map = {
	"./amex-icon.svg": "1f6a",
	"./buy-coin-blue-icon.svg": "2210",
	"./credit-card-icon.svg": "c973",
	"./diamond-icon.svg": "c282",
	"./diners-icon.svg": "34ee",
	"./discover-icon.svg": "c6b6d",
	"./follower-flame-icon.svg": "8250",
	"./full-profile-place-icon.svg": "aff6",
	"./gift-icon.svg": "26d4",
	"./google-play-icon.svg": "dd7e",
	"./greater-icon.svg": "824a",
	"./headphone-icon.svg": "4060",
	"./leader-board-icon.svg": "7e73",
	"./mastercard-icon.svg": "894d",
	"./number-one-icon.svg": "0d09",
	"./number-three-icon.svg": "9398",
	"./number-two-icon.svg": "947a",
	"./payment/card-icon.svg": "57a8",
	"./payment/coin-icon.svg": "6d35",
	"./payment/trash-icon.svg": "8a3b",
	"./place-icon.svg": "e143",
	"./plus-icon.svg": "bd72",
	"./profile-status-icon.svg": "257b",
	"./reseller-icon.svg": "4057",
	"./search-icon.svg": "3e7d",
	"./share-icon.svg": "986f",
	"./signup-google-icon.svg": "c258",
	"./signup-phone-icon.svg": "fcfd0",
	"./success-icon.svg": "d4a9",
	"./support-icon.svg": "23ce",
	"./unfollow-icon.svg": "0f77",
	"./validation-icon.svg": "e214",
	"./visa-icon.svg": "d795"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5ae";